import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { InsuranceDetailsForm } from '../../shared/InsuranceDetailsForm';
import { createInsuranceDetailsSchema } from '../../schema/InsuranceDetailsSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function UmbrellaInsuranceDetailsStep(): ReactElement {
  const dispatch = useDispatch();
  const { umbrellaInsuranceLastReviewed: umbrellaInsuranceLastReviewed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('last_checked_umbrella');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <CardPadding>
      <CardHeader
        header="When was the last time you looked over your umbrella insurance or
          coverage details?"
      />
      <Formik
        initialValues={{ umbrellaInsuranceLastReviewed }}
        onSubmit={onSubmit}
        validationSchema={createInsuranceDetailsSchema(
          'umbrellaInsuranceLastReviewed'
        )}
      >
        <Form ref={formRef}>
          <InsuranceDetailsForm name="umbrellaInsuranceLastReviewed" />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { UmbrellaInsuranceDetailsStep };
